
import React, { useState, useEffect } from 'react';
import { Row, Col, Spinner } from "reactstrap";

import ProfileHero from './ProfileHero';
import PersonalData from './PersonalData';
import UserData from './UserData';
import ChangePassword from './ChangePassword';

import { myUser } from '../../helpers/satiBack';
import './index.scss';

const ProfileConfig = () => {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    updateUser();
  }, []);

  const updateUser = () => {
    myUser()
      .then(data => setUser(data))
      .catch(err => console.error(err));
  }

  if (!user) {
    return (
      <div className="d-flex mt-5 justify-content-center">
        <Spinner/>
      </div>
    )
  }

  return (
    <React.Fragment>
      <div className="container-fluid">
        <Row>
          <Col>
            <div className="page-title-box d-flex justify-content-between">
              <h4 className="font-size-20 text-center">Configuración de perfil</h4>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={5} sm={12}>
            <Row>
              <Col>
                <ProfileHero user={user}/>
              </Col>
            </Row>
            <Row>
              <Col>
                <PersonalData user={user} updateUser={updateUser}/>
              </Col>
            </Row>
          </Col>
          <Col md={7} sm={12}>
            <Row>
              <Col>
                <UserData user={user} updateUser={updateUser}/>
              </Col>
            </Row>
            <Row>
              <Col>
                <ChangePassword/>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}

export default ProfileConfig;
